//    *GENERAL IMPORTS*   //
import { ThunkAction } from "redux-thunk"
import { AppStateType, InferActionsTypes } from "Redux/ReduxStore"

import { ProjectType } from "Redux/Types/ProjectsTypes"

////////////////////////////////////////////////////////////////////////

const initialState = {
  projects: [] as Array<ProjectType>,
  projectInfo: {} as ProjectType,
  lastItem: {},

  isLoading: true as boolean,
}

type initialStateType = typeof initialState

// *REDUCER* //
const ProjectsReducer = (
  state = initialState,
  action: ActionTypes
): initialStateType => {
  if (action.type === "SET_PROJECTS") {
    return {
      ...state,
      projects: action.projects,
      lastItem: action.lastItem,
    }
  }

  if (action.type === "SET_PROJECT_INFO") {
    return {
      ...state,
      projectInfo: action.projectInfo,
    }
  }

  if (action.type === "SET_LOADING_STATE") {
    return {
      ...state,
      isLoading: action.loadingState,
    }
  }

  return state
}

export default ProjectsReducer

///////////////////////////////////////////////////////////////////////

type ActionTypes = InferActionsTypes<typeof ActionCreatorsList>

//    *ACTION CREATORS*   //
export const ActionCreatorsList = {
  setProjectsActionCreator: (projects: Array<ProjectType>, lastItem: any) =>
    ({
      type: "SET_PROJECTS",
      projects,
      lastItem,
    } as const),

  setProjectInfoActionCreator: (projectInfo: ProjectType) =>
    ({
      type: "SET_PROJECT_INFO",
      projectInfo,
    } as const),

  setLoadingStateActionCreator: (loadingState: boolean) =>
    ({
      type: "SET_LOADING_STATE",
      loadingState,
    } as const),
}

//    *THUNKS*   //
type ThunkType = ThunkAction<Promise<void>, AppStateType, unknown, ActionTypes>

export const getProjectsThunkCreator = (): ThunkType => {
  return async (dispatch, getState, { getFirebase, getFirestore }: any) => {
    const firestore = getFirestore()

    const projectsRef = firestore.collection("projects").orderBy("ID")
    const data: {
      list: Array<ProjectType>
      last: any
      isNext: boolean
    } = await projectsRef.get().then((querySnapshot: any) => {
      const last = querySnapshot.docs[querySnapshot.docs.length - 1]
      let list = querySnapshot.docs.map((doc: any) => doc.data())

      return {
        list,
        last,
      }
    })

    dispatch(ActionCreatorsList.setProjectsActionCreator(data.list, data.last))
  }
}

export const getProjectInfoThunkCreator = (ID: string): ThunkType => {
  return async (dispatch, getState, { getFirebase, getFirestore }: any) => {
    const firestore = getFirestore()
    dispatch(ActionCreatorsList.setLoadingStateActionCreator(true))

    const projectsRef = firestore
      .collection("projects")
      .where("ID", "==", Number(ID))
    const data = await projectsRef.get().then((querySnapshot: any) => {
      return querySnapshot.docs.map((doc: any) => doc.data())[0]
    })

    dispatch(ActionCreatorsList.setLoadingStateActionCreator(false))
    dispatch(ActionCreatorsList.setProjectInfoActionCreator(data))
  }
}
